/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum NursingInterventionsEmarRecordsAliases {
  AMPLITUDE_MONITORING_FIELD = 'amplitude-monitoring-field',
  AMPLITUDE_MONITORING_INPUT = 'amplitude-monitoring-input',
  APAP_CHECKBOX = 'apap-checkbox',
  APAP_FIELD = 'apap-field',
  APAP_HOUR_AUTOCOMPLETE = 'apap-hour-autocomplete',
  APAP_HOUR_FIELD = 'apap-hour-field',
  APAP_HOUR_MAPPER = 'apap-hour-mapper',
  APAP_HOUR_TEXT = 'apap-hour-text',
  AUTO_PEEP_MONITORING_FIELD = 'auto-peep-monitoring-field',
  AUTO_PEEP_MONITORING_INPUT = 'auto-peep-monitoring-input',
  BLOOD_GLUCOSE_CONTROL_AUTOCOMPLETE = 'blood-glucose-control-autocomplete',
  BLOOD_GLUCOSE_CONTROL_FIELD = 'blood-glucose-control-field',
  BLOOD_GLUCOSE_CONTROL_MAPPER = 'blood-glucose-control-mapper',
  BLOOD_GLUCOSE_CONTROL_TEXT = 'blood-glucose-control-text',
  BREATHING_PATTERN_AUTOCOMPLETE = 'breathing-pattern-autocomplete',
  BREATHING_PATTERN_FIELD = 'breathing-pattern-field',
  BREATHING_PATTERN_MAPPER = 'breathing-pattern-mapper',
  BREATHING_PATTERN_TEXT = 'breathing-pattern-text',
  BTF_FIELD = 'btf-field',
  BTF_INPUT = 'btf-input',
  BTT_FIELD = 'btt-field',
  BTT_INPUT = 'btt-input',
  CD_PAIN_SCALE_AUTOCOMPLETE = 'cd-pain-scale-autocomplete',
  CD_PAIN_SCALE_FIELD = 'cd-pain-scale-field',
  CD_PAIN_SCALE_MAPPER = 'cd-pain-scale-mapper',
  CD_PAIN_SCALE_TEXT = 'cd-pain-scale-text',
  CO2_INSPIRED_MONITORING_FIELD = 'co2-inspired-monitoring-field',
  CO2_INSPIRED_MONITORING_INPUT = 'co2-inspired-monitoring-input',
  COMFORT_B_SCALE_FIELD = 'comfort-b-scale-field',
  COMFORT_B_SCALE_INPUT = 'comfort-b-scale-input',
  CONDUCT_RECORD_AUTOCOMPLETE = 'conduct-record-autocomplete',
  CONDUCT_RECORD_FIELD = 'conduct-record-field',
  CONDUCT_RECORD_MAPPER = 'conduct-record-mapper',
  CONDUCT_RECORD_TEXT = 'conduct-record-text',
  CONTENT_INFORMATION_HEADER = 'content-information-header',
  CONTEXTUAL_BAR_EMAR_RECORDS = 'contextual-bar-emar-records',
  CRIB_TEMPERATURE_FIELD = 'crib-temperature-field',
  CRIB_TEMPERATURE_INPUT = 'crib-temperature-input',
  CUFF_PRESSURE_MONITORING_FIELD = 'cuff-pressure-monitoring-field',
  CUFF_PRESSURE_MONITORING_INPUT = 'cuff-pressure-monitoring-input',
  CYCLE_FINAL_MONITORING_FIELD = 'cycle-final-monitoring-field',
  CYCLE_FINAL_MONITORING_INPUT = 'cycle-final-monitoring-input',
  DATE_OF_WEIGHT_FIELD = 'date-of-weight-field',
  DATE_OF_WEIGHT_INPUT = 'date-of-weight-input',
  DEVICE_INTAKE_OUTPUT_AUTOCOMPLETE = 'device-intake-output-autocomplete',
  DEVICE_INTAKE_OUTPUT_FIELD = 'device-intake-output-field',
  DEVICE_INTAKE_OUTPUT_MAPPER = 'device-intake-output-mapper',
  DEVICE_INTAKE_OUTPUT_TEXT = 'device-intake-output-text',
  DEVICE_INTERFACE_AUTOCOMPLETE = 'device-interface-autocomplete',
  DEVICE_INTERFACE_FIELD = 'device-interface-field',
  DEVICE_INTERFACE_MAPPER = 'device-interface-mapper',
  DEVICE_INTERFACE_TEXT = 'device-interface-text',
  DEVICE_NUMBER_FIELD = 'device-number-field',
  DEVICE_NUMBER_INPUT = 'device-number-input',
  DURATION_FIELD = 'duration-field',
  DURATION_INPUT = 'duration-input',
  DYNAMIC_COMPLIANCE_MONITORING_FIELD = 'dynamic-compliance-monitoring-field',
  DYNAMIC_COMPLIANCE_MONITORING_INPUT = 'dynamic-compliance-monitoring-input',
  DYNAMIC_DATA_TIME_FIELD = 'dynamic-data-time-field',
  DYNAMIC_DATA_TIME_INPUT = 'dynamic-data-time-input',
  EQUIPMENT_AUTOCOMPLETE = 'equipment-autocomplete',
  EQUIPMENT_FIELD = 'equipment-field',
  EQUIPMENT_MAPPER = 'equipment-mapper',
  EQUIPMENT_TEXT = 'equipment-text',
  EXPIRATION_TIME_MONITORING_FIELD = 'expiration-time-monitoring-field',
  EXPIRATION_TIME_MONITORING_INPUT = 'expiration-time-monitoring-input',
  EXPIRATORY_TIDAL_MONITORING_FIELD = 'expiratory-tidal-monitoring-field',
  EXPIRATORY_TIDAL_MONITORING_INPUT = 'expiratory-tidal-monitoring-input',
  FC_OXI_FIELD = 'fc-oxi-field',
  FC_OXI_INPUT = 'fc-oxi-input',
  FC_OXI_MONITORING_FIELD = 'fc-oxi-monitoring-field',
  FC_OXI_MONITORING_INPUT = 'fc-oxi-monitoring-input',
  FI_O2_MONITORING_FIELD = 'fiO2-monitoring-field',
  FI_O2_MONITORING_INPUT = 'fiO2-monitoring-input',
  FORM = 'form',
  FREQ_PROG_MONITORING_FIELD = 'freq-prog-monitoring-field',
  FREQ_PROG_MONITORING_INPUT = 'freq-prog-monitoring-input',
  FREQ_VENT_MONITORING_FIELD = 'freq-vent-monitoring-field',
  FREQ_VENT_MONITORING_INPUT = 'freq-vent-monitoring-input',
  FREQUENCY_AUTOCOMPLETE = 'frequency-autocomplete',
  FREQUENCY_FIELD = 'frequency-field',
  FREQUENCY_MAPPER = 'frequency-mapper',
  FREQUENCY_TEXT = 'frequency-text',
  G_WEIGHT_FIELD = 'g-weight-field',
  G_WEIGHT_INPUT = 'g-weight-input',
  HEART_RATE_FIELD = 'heart-rate-field',
  HEART_RATE_INPUT = 'heart-rate-input',
  HEIGHT_CENTIMETERS_FIELD = 'height-centimeters-field',
  HEIGHT_CENTIMETERS_INPUT = 'height-centimeters-input',
  HEIGHT_METERS_FIELD = 'height-meters-field',
  HEIGHT_METERS_INPUT = 'height-meters-input',
  HEIGHT_ORIGIN_AUTOCOMPLETE = 'height-origin-autocomplete',
  HEIGHT_ORIGIN_FIELD = 'height-origin-field',
  HEIGHT_ORIGIN_MAPPER = 'height-origin-mapper',
  HEIGHT_ORIGIN_TEXT = 'height-origin-text',
  HEIGHT_UNIT_MEASURE_AUTOCOMPLETE = 'height-unit-measure-autocomplete',
  HEIGHT_UNIT_MEASURE_FIELD = 'height-unit-measure-field',
  HEIGHT_UNIT_MEASURE_MAPPER = 'height-unit-measure-mapper',
  HEIGHT_UNIT_MEASURE_TEXT = 'height-unit-measure-text',
  HOUR_APAP_INTAKE_OUTPUT_AUTOCOMPLETE = 'hour-apap-intake-output-autocomplete',
  HOUR_APAP_INTAKE_OUTPUT_FIELD = 'hour-apap-intake-output-field',
  HOUR_APAP_INTAKE_OUTPUT_MAPPER = 'hour-apap-intake-output-mapper',
  HOUR_APAP_INTAKE_OUTPUT_TEXT = 'hour-apap-intake-output-text',
  HUMIDIFIER_FILTER_AUTOCOMPLETE = 'humidifier-filter-autocomplete',
  HUMIDIFIER_FILTER_FIELD = 'humidifier-filter-field',
  HUMIDIFIER_FILTER_MAPPER = 'humidifier-filter-mapper',
  HUMIDIFIER_FILTER_TEXT = 'humidifier-filter-text',
  HUMIDIFIER_TEMPERATURE_FIELD = 'humidifier-temperature-field',
  HUMIDIFIER_TEMPERATURE_INPUT = 'humidifier-temperature-input',
  IE_SIDE_AUTOCOMPLETE = 'ie-side-autocomplete',
  IE_SIDE_FIELD = 'ie-side-field',
  IE_SIDE_MAPPER = 'ie-side-mapper',
  IE_SIDE_TEXT = 'ie-side-text',
  INAUDIBLE_BP_CHECKBOX = 'Inaudible-bp-checkbox',
  INAUDIBLE_BP_FIELD = 'Inaudible-bp-field',
  INCUBATOR_HUMIDITY_FIELD = 'incubator-humidity-field',
  INCUBATOR_HUMIDITY_INPUT = 'incubator-humidity-input',
  INCUBATOR_TEMPERATURE_FIELD = 'incubator-temperature-field',
  INCUBATOR_TEMPERATURE_INPUT = 'incubator-temperature-input',
  INDICATION_AUTOCOMPLETE = 'indication-autocomplete',
  INDICATION_FIELD = 'indication-field',
  INDICATION_MAPPER = 'indication-mapper',
  INDICATION_TEXT = 'indication-text',
  INEPT_REASON_PAIN_AUTOCOMPLETE = 'inept-reason-pain-autocomplete',
  INEPT_REASON_PAIN_FIELD = 'inept-reason-pain-field',
  INEPT_REASON_PAIN_MAPPER = 'inept-reason-pain-mapper',
  INEPT_REASON_PAIN_TEXT = 'inept-reason-pain-text',
  INSPIRATORY_TIDAL_MONITORING_FIELD = 'inspiratory-tidal-monitoring-field',
  INSPIRATORY_TIDAL_MONITORING_INPUT = 'inspiratory-tidal-monitoring-input',
  INVASIVE_MECHANICAL_VENTILATION_DEVICE_AUTOCOMPLETE = 'invasive-mechanical-ventilation-device-autocomplete',
  INVASIVE_MECHANICAL_VENTILATION_DEVICE_FIELD = 'invasive-mechanical-ventilation-device-field',
  INVASIVE_MECHANICAL_VENTILATION_DEVICE_MAPPER = 'invasive-mechanical-ventilation-device-mapper',
  INVASIVE_MECHANICAL_VENTILATION_DEVICE_TEXT = 'invasive-mechanical-ventilation-device-text',
  IRRADIATION_TOPOGRAPHY_AUTOCOMPLETE = 'irradiation-topography-autocomplete',
  IRRADIATION_TOPOGRAPHY_FIELD = 'irradiation-topography-field',
  IRRADIATION_TOPOGRAPHY_MAPPER = 'irradiation-topography-mapper',
  IRRADIATION_TOPOGRAPHY_TEXT = 'irradiation-topography-text',
  KANGAROO_MOTHER_CARE_METHOD_CHECKBOX = 'kangaroo-mother-care-method-checkbox',
  KANGAROO_MOTHER_CARE_METHOD_FIELD = 'kangaroo-mother-care-method-field',
  KG_WEIGHT_FIELD = 'kg-weight-field',
  KG_WEIGHT_INPUT = 'kg-weight-input',
  KIND_OF_PAIN_AUTOCOMPLETE = 'kind-of-pain-autocomplete',
  KIND_OF_PAIN_FIELD = 'kind-of-pain-field',
  KIND_OF_PAIN_MAPPER = 'kind-of-pain-mapper',
  KIND_OF_PAIN_TEXT = 'kind-of-pain-text',
  LEFT_EYE_LIGHT_REACTION_AUTOCOMPLETE = 'left-eye-light-reaction-autocomplete',
  LEFT_EYE_LIGHT_REACTION_FIELD = 'left-eye-light-reaction-field',
  LEFT_EYE_LIGHT_REACTION_MAPPER = 'left-eye-light-reaction-mapper',
  LEFT_EYE_LIGHT_REACTION_TEXT = 'left-eye-light-reaction-text',
  LEFT_PULLEY_SIZE_AUTOCOMPLETE = 'left-pulley-size-autocomplete',
  LEFT_PULLEY_SIZE_FIELD = 'left-pulley-size-field',
  LEFT_PULLEY_SIZE_MAPPER = 'left-pulley-size-mapper',
  LEFT_PULLEY_SIZE_TEXT = 'left-pulley-size-text',
  LEVEL_OF_CONSCIOUSNESS_AUTOCOMPLETE = 'level-of-consciousness-autocomplete',
  LEVEL_OF_CONSCIOUSNESS_FIELD = 'level-of-consciousness-field',
  LEVEL_OF_CONSCIOUSNESS_MAPPER = 'level-of-consciousness-mapper',
  LEVEL_OF_CONSCIOUSNESS_TEXT = 'level-of-consciousness-text',
  LIPLINE_FIELD = 'lipline-field',
  LIPLINE_INPUT = 'lipline-input',
  MAEC_BIS_FIELD = 'maec-bis-field',
  MAEC_BIS_INPUT = 'maec-bis-input',
  MANEUVER_AUTOCOMPLETE = 'maneuver-autocomplete',
  MANEUVER_FIELD = 'maneuver-field',
  MANEUVER_MAPPER = 'maneuver-mapper',
  MANEUVER_TEXT = 'maneuver-text',
  MEMBER_PA_AUTOCOMPLETE = 'member-pa-autocomplete',
  MEMBER_PA_FIELD = 'member-pa-field',
  MEMBER_PA_MAPPER = 'member-pa-mapper',
  MEMBER_PA_TEXT = 'member-pa-text',
  MODALITY_AUTOCOMPLETE = 'modality-autocomplete',
  MODALITY_FIELD = 'modality-field',
  MODALITY_MAPPER = 'modality-mapper',
  MODALITY_TEXT = 'modality-text',
  NEWBORN_INTAKE_OUTPUT_CHECKBOX = 'newborn-intake-output-checkbox',
  NEWBORN_INTAKE_OUTPUT_FIELD = 'newborn-intake-output-field',
  NURSING_INTERVENTIONS_EMAR_RECORDS_LAYOUT = 'nursing-interventions-emar-records-layout',
  O2_ADDITIONAL_FIELD = 'o2-additional-field',
  O2_ADDITIONAL_INPUT = 'o2-additional-input',
  OBSERVATION_INTAKE_OUTPUT_FIELD = 'observation-intake-output-field',
  OBSERVATION_INTAKE_OUTPUT_TEXT_AREA = 'observation-intake-output-text-area',
  OBSTETRIC_RECORDS_BCF2_FIELD = 'obstetric-records-bcf2-field',
  OBSTETRIC_RECORDS_BCF2_INPUT = 'obstetric-records-bcf2-input',
  OBSTETRIC_RECORDS_BCF3_FIELD = 'obstetric-records-bcf3-field',
  OBSTETRIC_RECORDS_BCF3_INPUT = 'obstetric-records-bcf3-input',
  OBSTETRIC_RECORDS_FIELD = 'obstetric-records-field',
  OBSTETRIC_RECORDS_INPUT = 'obstetric-records-input',
  OCCURRENCES_INTAKE_OUTPUT_FIELD = 'occurrences-intake-output-field',
  OCCURRENCES_INTAKE_OUTPUT_INPUT = 'occurrences-intake-output-input',
  ORIGIN_WIDTH_AUTOCOMPLETE = 'origin-width-autocomplete',
  ORIGIN_WIDTH_FIELD = 'origin-width-field',
  ORIGIN_WIDTH_MAPPER = 'origin-width-mapper',
  ORIGIN_WIDTH_TEXT = 'origin-width-text',
  OUTCAST_SIDE_AUTOCOMPLETE = 'outcast-side-autocomplete',
  OUTCAST_SIDE_FIELD = 'outcast-side-field',
  OUTCAST_SIDE_MAPPER = 'outcast-side-mapper',
  OUTCAST_SIDE_TEXT = 'outcast-side-text',
  PAD_FIELD = 'pad-field',
  PAD_INPUT = 'pad-input',
  PAIN_COMFORT_LEVEL_AUTOCOMPLETE = 'pain-comfort-level-autocomplete',
  PAIN_COMFORT_LEVEL_FIELD = 'pain-comfort-level-field',
  PAIN_COMFORT_LEVEL_MAPPER = 'pain-comfort-level-mapper',
  PAIN_COMFORT_LEVEL_TEXT = 'pain-comfort-level-text',
  PAIN_CONDITION_AUTOCOMPLETE = 'pain-condition-autocomplete',
  PAIN_CONDITION_FIELD = 'pain-condition-field',
  PAIN_CONDITION_MAPPER = 'pain-condition-mapper',
  PAIN_CONDITION_TEXT = 'pain-condition-text',
  PAIN_SCALE_FETCH = 'pain-scale-fetch',
  PAIN_SCALE_FIELD = 'pain-scale-field',
  PAIN_SCALE_INPUT = 'pain-scale-input',
  PAM_FIELD = 'pam-field',
  PAM_INPUT = 'pam-input',
  PANEL_CONTENT = 'panel-content',
  PANEL_SUCCESS_LOADER = 'panel-success-loader',
  PAO2_FIO2_MONITORING_FIELD = 'pao2-fio2-monitoring-field',
  PAO2_FIO2_MONITORING_INPUT = 'pao2-fio2-monitoring-input',
  PARTIAL_MINUTE_MONITORING_FIELD = 'partial-minute-monitoring-field',
  PARTIAL_MINUTE_MONITORING_INPUT = 'partial-minute-monitoring-input',
  PAS_FIELD = 'pas-field',
  PAS_INPUT = 'pas-input',
  PASITION_PA_FIELD = 'pasition-pa-field',
  PC_MONITORING_FIELD = 'pc-monitoring-field',
  PC_MONITORING_INPUT = 'pc-monitoring-input',
  PEP_MONITORING_FIELD = 'pep-monitoring-field',
  PEP_MONITORING_INPUT = 'pep-monitoring-input',
  PIA_MMHG_FIELD = 'pia-mmhg-field',
  PIA_MMHG_INPUT = 'pia-mmhg-input',
  PIC_CATHETER_TEMPERATURE_FIELD = 'pic-catheter-temperature-field',
  PIC_CATHETER_TEMPERATURE_INPUT = 'pic-catheter-temperature-input',
  PIC_MMHG_FIELD = 'pic-mmhg-field',
  PIC_MMHG_INPUT = 'pic-mmhg-input',
  PLACE_AUTOCOMPLETE = 'place-autocomplete',
  PLACE_FIELD = 'place-field',
  PLACE_MAPPER = 'place-mapper',
  PLACE_TEXT = 'place-text',
  POSITION_PA_AUTOCOMPLETE = 'position-pa-autocomplete',
  POSITION_PA_MAPPER = 'position-pa-mapper',
  POSITION_PA_TEXT = 'position-pa-text',
  POSS_SCALE_AUTOCOMPLETE = 'poss-scale-autocomplete',
  POSS_SCALE_FIELD = 'poss-scale-field',
  POSS_SCALE_MAPPER = 'poss-scale-mapper',
  POSS_SCALE_TEXT = 'poss-scale-text',
  PPA_MMHG_FIELD = 'ppa-mmhg-field',
  PPA_MMHG_INPUT = 'ppa-mmhg-input',
  PPC_MMHG_FIELD = 'ppc-mmhg-field',
  PPC_MMHG_INPUT = 'ppc-mmhg-input',
  PROGRAMMED_TIDAL_MONITORING_FIELD = 'programmed-tidal-monitoring-field',
  PROGRAMMED_TIDAL_MONITORING_INPUT = 'programmed-tidal-monitoring-input',
  PVC_MMHF_FIELD = 'pvc-mmhf-field',
  PVC_MMHF_INPUT = 'pvc-mmhf-input',
  RADIANCE_FIELD = 'radiance-field',
  RADIANCE_INPUT = 'radiance-input',
  RAMSAY_SCALE_AUTOCOMPLETE = 'ramsay-scale-autocomplete',
  RAMSAY_SCALE_FIELD = 'ramsay-scale-field',
  RAMSAY_SCALE_MAPPER = 'ramsay-scale-mapper',
  RAMSAY_SCALE_TEXT = 'ramsay-scale-text',
  RASS_SCALE_AUTOCOMPLETE = 'rass-scale-autocomplete',
  RASS_SCALE_FIELD = 'rass-scale-field',
  RASS_SCALE_MAPPER = 'rass-scale-mapper',
  RASS_SCALE_TEXT = 'rass-scale-text',
  RESPIRATION_TYPE_AUTOCOMPLETE = 'respiration-type-autocomplete',
  RESPIRATION_TYPE_FIELD = 'respiration-type-field',
  RESPIRATION_TYPE_MAPPER = 'respiration-type-mapper',
  RESPIRATION_TYPE_TEXT = 'respiration-type-text',
  RESPIRATORY_FREQUENCY_FIELD = 'respiratory-frequency-field',
  RESPIRATORY_FREQUENCY_INPUT = 'respiratory-frequency-input',
  RESULT_FIELD = 'result-field',
  RESULT_INPUT = 'result-input',
  RIGHT_EYE_LIGHT_REACTION_AUTOCOMPLETE = 'right-eye-light-reaction-autocomplete',
  RIGHT_EYE_LIGHT_REACTION_FIELD = 'right-eye-light-reaction-field',
  RIGHT_EYE_LIGHT_REACTION_MAPPER = 'right-eye-light-reaction-mapper',
  RIGHT_EYE_LIGHT_REACTION_TEXT = 'right-eye-light-reaction-text',
  RIGHT_PULLEY_SIZE_AUTOCOMPLETE = 'right-pulley-size-autocomplete',
  RIGHT_PULLEY_SIZE_FIELD = 'right-pulley-size-field',
  RIGHT_PULLEY_SIZE_MAPPER = 'right-pulley-size-mapper',
  RIGHT_PULLEY_SIZE_TEXT = 'right-pulley-size-text',
  RIKER_SCALE_AUTOCOMPLETE = 'riker-scale-autocomplete',
  RIKER_SCALE_FIELD = 'riker-scale-field',
  RIKER_SCALE_MAPPER = 'riker-scale-mapper',
  RIKER_SCALE_TEXT = 'riker-scale-text',
  SATURATION_CONDITION_AUTOCOMPLETE = 'saturation-condition-autocomplete',
  SATURATION_CONDITION_FIELD = 'saturation-condition-field',
  SATURATION_CONDITION_MAPPER = 'saturation-condition-mapper',
  SATURATION_CONDITION_TEXT = 'saturation-condition-text',
  SATURATION_MEMBER_AUTOCOMPLETE = 'saturation-member-autocomplete',
  SATURATION_MEMBER_FIELD = 'saturation-member-field',
  SATURATION_MEMBER_MAPPER = 'saturation-member-mapper',
  SATURATION_MEMBER_TEXT = 'saturation-member-text',
  SATURATION_O2_FIELD = 'saturation-o2-field',
  SATURATION_O2_INPUT = 'saturation-o2-input',
  SATURATION_O2_MONITORING_FIELD = 'saturation-o2-monitoring-field',
  SATURATION_O2_MONITORING_INPUT = 'saturation-o2-monitoring-input',
  SC_FIELD = 'sc-field',
  SC_INPUT = 'sc-input',
  SIDE_INTAKE_OUTPUT_AUTOCOMPLETE = 'side-intake-output-autocomplete',
  SIDE_INTAKE_OUTPUT_FIELD = 'side-intake-output-field',
  SIDE_INTAKE_OUTPUT_MAPPER = 'side-intake-output-mapper',
  SIDE_INTAKE_OUTPUT_TEXT = 'side-intake-output-text',
  SUCCESS_LOADER = 'success-loader',
  TEMPERATURE_FIELD = 'temperature-field',
  TEMPERATURE_INPUT = 'temperature-input',
  TEXT_NURSING_INTERVENTIONS_INFORMATION = 'text-nursing-interventions-information',
  TIME_COURSE_AUTOCOMPLETE = 'time-course-autocomplete',
  TIME_COURSE_FIELD = 'time-course-field',
  TIME_COURSE_MAPPER = 'time-course-mapper',
  TIME_COURSE_TEXT = 'time-course-text',
  TOBIN_INDEX_MONITORING_FIELD = 'tobin-index-monitoring-field',
  TOBIN_INDEX_MONITORING_INPUT = 'tobin-index-monitoring-input',
  TOPOGRAPHY_AUTOCOMPLETE = 'topography-autocomplete',
  TOPOGRAPHY_FIELD = 'topography-field',
  TOPOGRAPHY_INTAKE_OUTPUT_AUTOCOMPLETE = 'topography-intake-output-autocomplete',
  TOPOGRAPHY_INTAKE_OUTPUT_FIELD = 'topography-intake-output-field',
  TOPOGRAPHY_INTAKE_OUTPUT_MAPPER = 'topography-intake-output-mapper',
  TOPOGRAPHY_INTAKE_OUTPUT_TEXT = 'topography-intake-output-text',
  TOPOGRAPHY_MAPPER = 'topography-mapper',
  TOPOGRAPHY_TEXT = 'topography-text',
  TYPE_INTAKE_OUTPUT_AUTOCOMPLETE = 'type-intake-output-autocomplete',
  TYPE_INTAKE_OUTPUT_FIELD = 'type-intake-output-field',
  TYPE_INTAKE_OUTPUT_MAPPER = 'type-intake-output-mapper',
  TYPE_INTAKE_OUTPUT_TEXT = 'type-intake-output-text',
  VITAL_CAPACITY_MONITORING_FIELD = 'vital-capacity-monitoring-field',
  VITAL_CAPACITY_MONITORING_INPUT = 'vital-capacity-monitoring-input',
  VOLUME_INTAKE_OUTPUT_FIELD = 'volume-intake-output-field',
  VOLUME_INTAKE_OUTPUT_INPUT = 'volume-intake-output-input',
  WEIGHT_INTAKE_OUTPUT_FIELD = 'weight-intake-output-field',
  WEIGHT_INTAKE_OUTPUT_INPUT = 'weight-intake-output-input',
  WEIGHT_UNIT_MEASURE_AUTOCOMPLETE = 'weight-unit-measure-autocomplete',
  WEIGHT_UNIT_MEASURE_FIELD = 'weight-unit-measure-field',
  WEIGHT_UNIT_MEASURE_MAPPER = 'weight-unit-measure-mapper',
  WEIGHT_UNIT_MEASURE_TEXT = 'weight-unit-measure-text',
}
export { NursingInterventionsEmarRecordsAliases };
